import { Component } from '@angular/core';
import { ContactUsDefaultValues, ContactUsModel } from 'src/app/components/contactus/contactusmodel';
import { ContactusService } from 'src/app/services/contactus.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent {

  contactusModel:ContactUsModel=ContactUsDefaultValues();
  translation:any
  constructor(private contactusservice:ContactusService,private toastservice:ToastService,private translateservice:TranslationService) { }

  ngOnInit(): void {  
    this.translateservice.getTranslation().subscribe({
      next: (translation) => {
        this.translation= translation
      }
    })
  }
  onSubmit()
  {
    this.contactusservice.createEnquiry(this.contactusModel).subscribe({
      next: (response) => {
        if(response.status)
        {
            this.toastservice.showMessage("Message submitted successfully. Someone from our team will contact you shortly.")
            this.contactusModel = ContactUsDefaultValues();
        }
      }
    })
  }
}
